﻿import { CustomerConstant } from "@/constants/customer-constant";

const ProductUtils = {
    isFuseProduct(route) {
        return route.path.includes(CustomerConstant.fuseProductSeName);
    },

    isPowerProduct(route) {
        return route.path.includes(CustomerConstant.powerProductSeName);
    },

    highlights(source, term) {
        let termLowerCased = term.toLowerCase(),
            sourceLowerCased = (source || '').toLowerCase(),
            start = 0,
            result = '';

        if (termLowerCased && sourceLowerCased && sourceLowerCased.includes(termLowerCased)) {
            result += source.substring(start, sourceLowerCased.indexOf(termLowerCased));

            start = sourceLowerCased.indexOf(termLowerCased);

            result += `<span class="highlight">${source.substr(start, termLowerCased.length)}</span>`;

            start += termLowerCased.length;

            if (start < source.length)
                result += source.substring(start);
        }

        return result.length ? result : source;
    }
};

export default ProductUtils;